import React, { createContext, useContext, PropsWithChildren } from 'react';

interface ExtraQueryParamsContextType {
  extraQueryParams?: Record<string, string>;
}

const ExtraQueryParamsContext = createContext<ExtraQueryParamsContextType | undefined>(undefined);

type ExtraQueryParamsProviderProps = ExtraQueryParamsContextType & PropsWithChildren;

export const ExtraQueryParamsProvider = ({
  children,
  extraQueryParams,
}: ExtraQueryParamsProviderProps): JSX.Element => {
  return (
    <ExtraQueryParamsContext.Provider value={{ extraQueryParams }}>{children}</ExtraQueryParamsContext.Provider>
  );
};

export const useExtraQueryParams = (): ExtraQueryParamsContextType => {
  return useContext(ExtraQueryParamsContext) ?? {};
};
